/** Count automatic character-card defaults and optional location rows, including incomplete editing rows. */
export function dramaPresetCounts(pack) {
  let location_count = 0
  let default_count = 0
  for (const person of pack?.characters ?? []) {
    if (person.id === pack.player_id) continue
    const config = person.drama_presets
    if (Array.isArray(config?.locations)) location_count += config.locations.length
    if (typeof person.image === 'string' && person.image.trim()) default_count += 1
  }
  return { location_count, default_count, total_asset_count: location_count + default_count }
}

/** Only optional location combinations reference performance-state images. */
export function dramaPresetStateReferences(pack, character_index, state_id) {
  const config = pack.characters?.[character_index]?.drama_presets
  const prefix = `characters.${character_index}.drama_presets`
  const references = []
  for (const [index, rule] of (Array.isArray(config?.locations) ? config.locations : []).entries()) {
    if (rule.state_id === state_id) references.push(`${prefix}.locations.${index}.state_id`)
  }
  return references
}
